<script>
export default {
    name: "smart-loop-setting",
    props: {
        disabled: Boolean,
        value: {}
    },
    computed: {
        label() {
            return Lang.langGet("Loop-Settings");
        },
        hint() {
            return Lang.langGet("Check system requirements in hardware.ini.");
        },
        items() {
            return [
                {value: 0, text: Lang.langGet("Play the whole campaign all the way through")},
                {value: 1, text: Lang.langGet("Interrupt after each event")},
                {value: 2, text: Lang.langGet("Always start with the first element")},
                {value: 3, text: Lang.langGet("Automatic frequency control")},
                {value: 4, text: Lang.langGet("Automatic frequency control (in blocks if necessary)")},
                {value: 5, text: Lang.langGet("Up to ... elements in a row")},
                {value: 6, text: Lang.langGet("Up to ... seconds in a row")}
            ];
        },
    }
}
</script>

<template>
    <v-select-custom
        :value="value"
        @input="$emit('input', $event)"
        :label="label"
        :hint="hint"
        :disabled="disabled"
        :items="items"
        @change="$emit('change', $event)"
    />
</template>
